<template>
    <div class="payment">
        <div class="HomeHeader">
            <a-row class="top">
                <a-col :span="10">
                <img src="@assets/img/logo.png" @click="router.push({
                    name : 'home'
                })"/>
                </a-col>
                <a-col :span="14">


                </a-col>  
            </a-row>
        
        </div>
        <div class='content_top'>
            <div class='info_content'>
                <div class='info_left'>
                    <div class='money'>
                        订单金额：<span>¥3000</span>
                    </div>
                    <div class='time'>支付剩余时间 <span>13:51</span> ,超时订单可能会被取消</div>
                    <div class='line'></div>
                    <div class='top_round'></div>
                    <div class='btm_round'></div>
                </div>

                <div class='info_right'>
                    <div class='title'>
                        北京 - 鞍山 单程票
                    </div>
                    <div class='right_dero'>
                        行程信息:<span>大兴国际机场(BJD) - 鞍山机场(AS) | MU662 | V | 2020-12-29 09:55</span>
                    </div>
                    <div class='right_dero'>
                        订单编号:<span>20123102123123</span>
                    </div>
                    <div class='right_dero'>
                        乘客信息:<span>刘子阳、韩发祥</span>
                    </div>

                </div>

                

            </div>
            
            <div class='tips'>票价变动频繁,请在14分钟内完成支付以免耽误出行</div>   

        </div>
        <div class='pay_type'>
            <div class='type_cont active'>
                <div  class='action_sanjiao'></div>
                <img src='@assets/img/yuer.png'>  
                <div>
                    <div class='type_title'>余额支付</div>
                    <div class='type_num'>¥281,192.01</div>
                </div>
            </div>
            <div class='type_cont'>
                <div class='action_sanjiao'></div>
                <img src='@assets/img/wx.png'>  
                <div>
                    <div class='type_title'>微信支付</div>
                    <div class='type_num wx'>扫描二维码支付</div>
                </div>
            </div>
            <div class='type_cont'>
                <div class='action_sanjiao'></div>
                <img src='@assets/img/ali.png'>  
                <div>
                    <div class='type_title'>支付宝支付</div>
                    <div class='type_num wx'>扫描二维码支付</div>
                </div>
            </div>
        </div>

        <div class='submitBtn_cont'>
            <a-button type="primary" class='submitBtn'>
                ¥300.00，去支付
            </a-button>

        </div>
    </div>
</template>
<script>
import { ref, watch ,computed } from 'vue'

import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'payment',
  components: {
 
  },
  setup () {
    
 




    return {

    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .active{
        border-color:#3999FB!important;
        .action_sanjiao{
            width: 0;
            height: 0;
            border-top:16.5px solid transparent;
            border-bottom:16.5px solid transparent;
            border-right:16.5px solid transparent;
            border-left:16.5px solid #3999FB;
            position: absolute;
            right: -17px;
            top:-17px;
            transform: rotate(-45deg);
        }
       
    }
    .submitBtn_cont{
        display: flex;
        justify-content: center;
        margin-top: 250px;
    }
    .submitBtn{
        background: #FFAB00;
        border-color:#FFAB00;
        font-size: 25px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        width: 360px;
        height: 55px;
        border-radius: 2px;
    }
    .pay_type{
        width: 1200px;
        margin: 0 auto;
        padding: 28px 37px;
        display: flex;
        justify-content: flex-start;
        .type_cont{
            width: 160px;
            height: 68px;
            margin-right: 20px;
            border-radius: 2px;
            border: 1px solid #DBDCE0;
            display: flex;
            justify-content: flex-start;
            padding-left:13px;
            align-items: center;
            cursor: pointer;
            position: relative;
            img{
                width: 30px;
                height: 30px;
                margin-right: 8px;
            }
            .type_title{
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                position: relative;
                top:1.5px;
            }
            .type_num{
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FD5739;
                position: relative;
                top:-1.5px;
            }
            .wx{
                color: #DBDCE0!important;
            }
        }
    }
    .content_top{
        padding:28px 0;
        background: #409EFF;
        position: relative;
        .tips{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            position: absolute;
            width: 1200px;
            bottom: 3px;
            left: 50%;
            margin-left: -600px;
        }
    }
    .info_content{
        width: 1200px;
        margin: 0 auto;
        background: #FFFFFF;
        height: 240px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        position: relative;
        
        .info_left{
            width: 480px;
            padding-left:50px;
            display: flex;
            flex-direction:column;
            justify-content: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            position: relative;
            .money{
                position: relative;
                top:-5px;
                span{
                    font-size: 35px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FD5739;
                }
            }
            .time{
                position: relative;
                top:-5px;
                span{
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FD5739;
                }
            }
            .line{
                position: absolute;
                width: 0.5px;
                background: #CDCCCD;
                height: 174px;
                right: 0;
                top:33px;
            }
            .top_round{
                width: 60px;
                height: 60px;
                background: #409EFF;
                border-radius: 50%;
                position: absolute;
                top:-33px;
                right: -28px;
            }
            .btm_round{
                width: 60px;
                height: 60px;
                background: #409EFF;
                border-radius: 50%;
                position: absolute;
                bottom:-33px;
                right: -28px;
            }

        }
        .info_right{
            width: 710px;
            padding-left:50px;
            display: flex;
            flex-direction:column;
            justify-content: center;
            .title{
                font-size: 22px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #000000;
            }
            .right_dero{
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #000000;
                margin-top: 8px;
                span{
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    margin-left:10px;
                }
            }

        }
    }
    
    .top {
        width: 1200px;
        height: 90px;
        line-height: 90px;
        margin: 0 auto;
        .ant-col-10 {
        text-align: left;
        img {
            height: 68px;
            cursor: pointer;
        }
        }
        .ant-col-14 {
        text-align: right;
        color: #6d7278;
        .action {
            color: #0D6DBF;
            margin: 0 4px;
        }
        span {
            color: #0d6dbf;
            margin-left: 6px;
            cursor: pointer;
            text-decoration: underline;
        }
        }
    }
    .nav {
        width: 100%;
        height: 40px;
        background: #409EFF;
        color: #ffffff;
        .main {
        width: 1200px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        .ant-col-14 {
            text-align: left;
            span {
            display: inline-block;
            width: 65px;
            height: 40px;
            text-align: center;
            cursor: pointer;
            }
            .train {
            background: #0D6DBF;
            position: relative;
            span{
                display: block;
                width: 0;
                height: 0;
                border: 7.5px solid #fff;
                position: absolute;
                bottom: 0;
                left:50%;
                margin-left: -7.5px;
                border-right:7.5px solid transparent;
                border-top:7.5px solid transparent;
                border-left:7.5px solid transparent;
            }
            }
        }
            .ant-col-10 {
                text-align: right;
                span {
                cursor: pointer;
                }
            }
        }
    }

</style>
